"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Fleet API
 */
var fleet_service_1 = require("./fleet/fleet.service");
exports.fleet = fleet_service_1.fleet;
var cs_fleet_service_1 = require("./cs-fleet/cs-fleet.service");
exports.csfleet = cs_fleet_service_1.csfleet;
var availability_service_1 = require("./cs-fleet/availability/availability.service");
exports.availability = availability_service_1.availability;
/**
 * Carrental API
 */
var carrental_service_1 = require("./carrental/carrental.service");
exports.carrental = carrental_service_1.carrental;
/**
 * User Company API
 */
var user_company_service_1 = require("./user-company/user-company.service");
exports.userCompany = user_company_service_1.userCompany;
var documentation_service_1 = require("./user-company/documentation/documentation.service");
exports.documentation = documentation_service_1.documentation;
var chauffeur_service_1 = require("./user-company/chauffeur/chauffeur.service");
exports.chauffeur = chauffeur_service_1.chauffeur;
var agent_service_1 = require("./user-company/agent/agent.service");
exports.agent = agent_service_1.agent;
var ride_hailing_service_1 = require("./ride-hailing/ride-hailing.service");
exports.ridehailing = ride_hailing_service_1.ridehailing;
/**
 * Invoicing API
 */
var delivery_note_service_1 = require("./invoicing/delivery-notes/delivery-note.service");
exports.deliveryNote = delivery_note_service_1.deliveryNote;
var invoices_service_1 = require("./invoicing/invoices/invoices.service");
exports.invoices = invoices_service_1.invoices;
var sap_service_1 = require("./sap/sap.service");
exports.sap = sap_service_1.sap;
/**
 * Fleet Invoicing API
 */
var fleet_invoicing_service_1 = require("./fleet-invoicing/fleet-invoicing.service");
exports.fleetInvoicing = fleet_invoicing_service_1.fleetInvoicing;
/**
 * Payments API
 */
var payment_methods_service_1 = require("./payments/payment-methods/payment-methods.service");
exports.paymentMethods = payment_methods_service_1.paymentMethods;
var payouts_service_1 = require("./payments/payouts/payouts.service");
exports.payouts = payouts_service_1.payouts;
var payment_media_service_1 = require("./payments/payment-media/payment-media.service");
exports.paymentMedia = payment_media_service_1.paymentMedia;
/**
 * Business intelligence API
 */
var reports_service_1 = require("./business-intelligence/reports/reports.service");
exports.reports = reports_service_1.reports;
/**
 * Pricing API
 */
var tariffs_service_1 = require("./pricing/tariffs/tariffs.service");
exports.tariffs = tariffs_service_1.tariffs;
/**
 * App global endpoints
 */
var app_service_1 = require("./app/app.service");
exports.app = app_service_1.app;
